import Button from '../ui/Button';

export default function EmptyState({ icon = '📭', title, message, action, actionLabel, className = '' }) {
  return (
    <div className={`flex flex-col items-center justify-center py-16 px-4 text-center ${className}`}>
      {/* String icon → big emoji; React node (line icon) → soft muted square.
          `icon &&` so an explicit null/false hides it — typeof null === 'object'
          would otherwise hit the square branch and render an empty tile. */}
      {icon && (typeof icon === 'string' ? (
        <div className="text-6xl mb-6">{icon}</div>
      ) : (
        <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-cream-200/70 text-ink-400">{icon}</div>
      ))}
      <h3 className="font-display text-xl font-semibold text-ink mb-2">{title}</h3>
      {message && <p className="text-ink-500 max-w-md mb-6">{message}</p>}
      {action && (
        <Button onClick={action}>
          {actionLabel || 'Acțiune'}
        </Button>
      )}
    </div>
  )
}
